import React from 'react';
export const StaticCurrency = _ref => {
  let {
    value
  } = _ref;
  return /*#__PURE__*/React.createElement("span", null, value);
};
//# sourceMappingURL=static-currency.react-component.js.map